import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import { useStyles } from 'src/features/Advisors/Applications/SummaryMortgage/SummaryMortgageLanding.styles'
import Button from 'src/components/Buttons/Button';
import ChevronLeftIcon from 'src/assets/icons/chevron-left.svg';
import Box from '@mui/material/Box';
import { mapIndexed } from 'src/utilities/visualFieldsMapper';
import { pathOr } from 'ramda';
import Typography from '@mui/material/Typography';
import { Breakpoint } from '@mui/system';

interface Props {
    showModal: boolean;
    modalTitle: any;
    toggleModal: any;
    modalDescription?: string;
    modalContent?: any;
    disabled?: any;
    showGoBack?: any;
    onGoBack?: any;
    buttonContainer?: {
        align: string
    }
    modalSize?: Breakpoint;
    contentStyles?: any;
    titleStyles?: any;
    contentComponent?: JSX.Element;
    actions: {
        buttonText: string;
        onClick: () => void;
        className?: string;
        buttonVariant?: string;
        disabled?: boolean;
        loading?:boolean
    }[]

}
type CombinedProps = Props
const ActionModal: React.FC<CombinedProps> = (props: CombinedProps) => {
    const {
        showModal,
        modalTitle,
        toggleModal,
        modalContent,
        modalSize,
        contentStyles,
        titleStyles,
        actions,
        onGoBack,
        modalDescription,
        showGoBack = true,
        buttonContainer = {}
    } = props;

    const classes = useStyles()

    const buttonAlignment = pathOr("center", ["align"], buttonContainer)
    const renderButtons = () => {
        return (<Box sx={{
            borderTop: '1px solid #EEE',
            padding: "20px",
            textAlign: buttonAlignment,
        }}>
            {mapIndexed((action: any, index: number) => {
                const { buttonText, buttonVariant, onClick, disabled, className, loading } = action;
                return (<Button
                    px={40}
                    key={`action_modal_button_${index}`}
                    py={12}
                    text={buttonText}
                    variant={buttonVariant || 'contained'}
                    onClick={onClick}
                    loading={loading}
                    className={className || classes.footerBtn}
                    data-test-id={`t--action-modal-button-${index}`}
                    disabled={disabled}
                />)
            }, actions)}
        </Box>)
    }

    return (
        <Dialog data-test-id={'t--action-modal-popup'} open={showModal} onClose={toggleModal} maxWidth={modalSize ? modalSize : 'lg'} fullWidth>
            <Box className={classes.headerWrapper}>
                {showGoBack && <Button
                    px={30}
                    py={6}
                    text='Go Back'
                    variant='text'
                    onClick={onGoBack || toggleModal}
                    startIcon={<ChevronLeftIcon />}
                    className={classes.goBackBtn}
                />}
                <DialogTitle className={classes.dataDialogTitle} sx={titleStyles}>
                    {modalTitle}
                </DialogTitle>
            </Box>
            <DialogContent sx={contentStyles}>
                {modalDescription && <Box mb={4}>
                    <Typography align="center" color="basic.darkGrey">
                        {modalDescription}
                    </Typography>
                </Box>}
                {modalContent && modalContent}
            </DialogContent>
            {renderButtons()}
        </Dialog>
    )
}
export default ActionModal;
